// removed by extract-text-webpack-plugin
module.exports = {"weather":"CurrentWeather__weather__fK3lt","city":"CurrentWeather__city__2uPR_","date":"CurrentWeather__date__2-R63","description":"CurrentWeather__description__C-haY","feel":"CurrentWeather__feel__3Dz1o","main":"CurrentWeather__main__1sku0","temp":"CurrentWeather__temp__v2-z4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CurrentWeather/CurrentWeather.css
// module id = 59
// module chunks = 0